import React from 'react';

const MarketCard = ({ title, value, helper, tone = 'slate' }) => {
  const toneClasses = {
    slate: 'border-slate-200 bg-white text-slate-900',
    amber: 'border-amber-200 bg-amber-50/80 text-amber-900',
    cyan: 'border-cyan-200 bg-cyan-50/80 text-cyan-900',
    violet: 'border-violet-200 bg-violet-50/80 text-violet-900',
  };

  return (
    <div className={`rounded-[24px] border px-5 py-4 shadow-sm ${toneClasses[tone] || toneClasses.slate}`}>
      <p className="text-[11px] font-semibold uppercase tracking-[0.22em] opacity-75">{title}</p>
      <p className="mt-2 text-2xl font-black tracking-tight">{value}</p>
      <p className="mt-2 text-sm leading-6 opacity-75">{helper}</p>
    </div>
  );
};

export default function ServiceMarketView() {
  return (
    <div className="space-y-5">
      <div className="grid grid-cols-1 gap-4 xl:grid-cols-3">
        <MarketCard
          title="Combustible"
          value="Próximamente"
          helper="Acá vamos a mostrar el valor de referencia para entender si el costo operativo del viaje quedó viejo."
          tone="amber"
        />
        <MarketCard
          title="Peajes"
          value="Próximamente"
          helper="Vamos a concentrar referencias oficiales para que la operación tenga contexto real sin salir de G-CENTRA."
          tone="cyan"
        />
        <MarketCard
          title="Índice logístico"
          value="Próximamente"
          helper="Este bloque va a resumir cómo viene el mercado para ayudarte a revisar márgenes y precios de servicio."
          tone="violet"
        />
      </div>

      <div className="rounded-[28px] border border-dashed border-slate-300 bg-slate-50/70 px-6 py-8">
        <p className="text-base font-bold text-slate-900">Precios de mercado</p>
        <p className="mt-2 max-w-3xl text-sm leading-6 text-slate-500">
          Esta sección va a funcionar como referencia automática del mercado. La app te va a mostrar combustible,
          peajes e índice logístico para que entiendas cómo se mueven los costos y después decidas si ajustás
          tarifas, márgenes o reglas comerciales.
        </p>
        <div className="mt-5 grid gap-3 md:grid-cols-3">
          {[
            'Referencia visible y actualizada',
            'No cambia tu liquidación automáticamente',
            'Sirve para decidir mejor precios y márgenes',
          ].map((item) => (
            <div key={item} className="rounded-[20px] border border-slate-200 bg-white px-4 py-3 text-sm font-medium text-slate-700 shadow-sm">
              {item}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
